/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/ongoing/probability-distributions.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/ongoing/probability-distributions.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/probability-distributions.mdx';

const metadata = {
  slug: "probability-distributions",
  title: "Probability Distributions",
  author: "Christian Battaglia",
  description: "An ongoing exploration of probability from first principles — discrete vs continuous data, Bernoulli to Poisson distributions, Bayesian reasoning, quantum probability, and the axiomatic foundations that tie it all together.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-09-04T00:00:00.000Z",
  
  readTime: "7 min read",
  tags: ["probability","statistics","Bayesian","quantum mechanics","distributions","mathematics","data science","axioms"],
};

export const Route = createFileRoute('/blog/posts/probability-distributions')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/probability-distributions',
    image: '/og/blog/probability-distributions.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
